import React, { Component } from 'react';
import OuterHeader from '../Layout/OuterHeader';
import Dashboard from '../Dashboard';
import InnerHeader from '../Layout/InnerHeader';
import NavBar from '../Layout/NavBar';
import Footer from "../Layout/Footer";
import '../../css/Activity.css';
import { withFirebase } from '../../config';
import { Button, Icon } from 'semantic-ui-react';
import "bootstrap/dist/css/bootstrap.min.css";
import { fetchQuestionsCategories } from '../../Actions/QuestionCategoryActions';
import { connect } from 'react-redux';
import porpTypes from 'prop-types';
import { addActivity } from '../../Actions/ActivityActions'
import { addQuestions, getActitvityQuestions } from '../../Actions/QuestionActions';
import { Link } from 'react-router-dom';
import AddActivityComponent from '../Activity/AddActivityComponent'

/* Routes */
import { ADD_SONG, SONG_EVALUATION } from '../../routes';

const INITIAL_STATE = {
    questions: []
}
class AddSongActivity extends Component {
    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }


    componentDidMount() {

        this.props.addActivity(this.props.song.name);
    }



    getValidatinData(questions) {
        console.log(questions)
        this.setState({ questions: questions })

    }
    handelSubmit = (e) =>{

        // console.log(this.state.questions === true)

        //  if (this.state.questions.length == 0) {
        //     alert("Empty Questions, Please add at least one Question")

        // }
    }

    render() {
        const {questions} = this.state;

        console.log(questions)
        // const isInvalid =
        // questions.length === 0 || questions == undefined ;

        return (
            <div className="container">
                <OuterHeader />
                <div className="container">
                    <div className="container-body">
                        <div className="row">

                            <Dashboard />
                            <div className="col-9">
                                <InnerHeader />
                                <div className="main-content">
                                    <div className="row">
                                        <div className="col-12 left-main-body" id="left-main-body">
                                            <NavBar />
                                            <br />
                                            <div className="container">
                                                <div className="main-progress-bar">
                                                    <ol className="progress-tracker">
                                                        <li className="step active s2-active"><span className="step-name small-font">ِAdd Song</span></li>
                                                        <li className="step active"><span className="step-name small-font">Add activity</span></li>
                                                        <li className="step "><span className="step-name small-font">Add Evaluation</span></li>
                                                        <li className="step"><span className="step-name small-font">Puplish Song</span></li>
                                                    </ol>
                                                </div>
                                                <br />

                                                <AddActivityComponent validateDataCallBack={this.getValidatinData.bind(this)} />
                                                <br />
                                                <Link to={SONG_EVALUATION}>
                                                    <Button icon labelPosition='right'

                                                        //disabled={isInvalid}
                                                        id="nextButton" >
                                                        Next
                                                            <Icon name='right arrow' />
                                                    </Button>
                                                </Link>

                                                <Link to={ADD_SONG}>
                                                    <Button icon labelPosition='left' id="episode_backButton" >
                                                        back
                                                            <Icon name='left arrow' />
                                                    </Button>
                                                </Link>

                                                {/* <Button id="episode_cancel">Cancel</Button> */}
                                                <br /> <br /> <br />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <Footer />
            </div>

        )
    }
}
AddSongActivity.porpTypes = {
    fetchQuestionsCategories: porpTypes.func.isRequired,
    questionCategories: porpTypes.func.isRequired,
    addQuestion: porpTypes.func.isRequired,
    getActitvityQuestions: porpTypes.func.isRequired,
    Activityquestions: porpTypes.func.isRequired
}
const mapStateToProps = state => ({
    questionCategories: state.questionCategories.items,
    activity: state.activities.item,
    question: state.questions.item,
    song: state.songs.item,
    activityQuestions: state.questions.items

});

export default withFirebase(connect(mapStateToProps, { fetchQuestionsCategories, addQuestions, getActitvityQuestions, addActivity })(AddSongActivity));
